import { useId } from "react";

export interface IFileButton {

    children? : string|JSX.Element[]|JSX.Element|null;
    
    accept: string;

    capture?: "user"|"environment";

    multiple?:boolean;

    onSelect: (e) => void;

}

export const FileButton = (props:IFileButton) => {

    const id = useId();

    var {children, ...rest} = props;

    const onSelect = (e) => {
    
        props.onSelect(e);

        e.target.value = "";

    }
    
    return <>
        <div className="btn btn-lg btn-outline-primary mr-messenger-file-button">
            <label id={id + "-label"} htmlFor={id + "-input"}>{props.children}</label>
            <input id={id + "-input"}  {...rest} type="file" onChange={onSelect} />
        </div>
        </>

}